import * as React from "react";

export default function SortAscendingIcon({ fill, ...props }: React.SVGProps<any>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 38 23" {...props}>
      <path
        d="M33.07 23H4.93C2.848 23 1.037 21.87.32 20.12c-.683-1.662-.25-3.558 1.128-4.949L15.543 1.61C16.546.596 17.929 0 19.313 0a4.43 4.43 0 0 1 3.17 1.307l14.058 13.851c1.391 1.404 1.824 3.3 1.14 4.963C36.966 21.869 35.155 23 33.07 23zM19.313 3.017c-.587 0-1.214.28-1.679.75L3.538 17.328c-.505.51-.675 1.1-.455 1.637.201.49.794 1.017 1.849 1.017H33.07c1.055 0 1.647-.526 1.848-1.017.222-.537.05-1.127-.48-1.662L20.382 3.454a1.445 1.445 0 0 0-1.069-.437z"
        fill={fill || "#627D98"}
        fillRule="nonzero"
      />
    </svg>
  );
}
